import {
  FETCH_DATA,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_ERROR,
} from './constants';

const initialState = {
  connectedServices: {},
  subscriptions: {},
  loadingBlocks: [],
};

export default function app(state = initialState, action) {
  switch (action.type) {
    case FETCH_DATA:
      return {
        ...state,
        isPreloader: true,
        loadingBlocks: action.loadingBlocks,
        error: null,
      };

    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        ...action.data,
        loadingBlocks: [],
        isPreloader: false,
      };

    case FETCH_DATA_ERROR:
      return {
        ...state,
        error: action.error,
        isPreloader: false,
      };

    default:
      return state;
  }
}
